var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-text',{staticClass:"text--primary"},[_c('px-cotacao-conjunta-resposta-finalizacao-table',{attrs:{"resposta":_vm.solicitacao.respostaCotacaoConjunta}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }